export enum TransactionsPathEnum {
  viewTransactions = '/view/transactions',
  viewOrders = '/view/orders',
}
